import { createAsyncThunk } from '@reduxjs/toolkit';
import { ax } from 'services/apiService';
// api/datahub_report/template_manager

export const getTemplates = createAsyncThunk('get-templates-all', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`datahub_report/template_manager`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const getTemplateDetail = createAsyncThunk('get-templates-detail', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`datahub_report/template_manager`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// datahub_report/add_template_manager
export const addTemplateManager = createAsyncThunk('add-templates-manager', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`datahub_report/add_template_manager`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// datahub_report/remove_template_manager
export const removeTemplateManager = createAsyncThunk('remove-templates-manager', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`datahub_report/remove_template_manager`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getTemplateCat = createAsyncThunk('get-template-cat', async (id: any) => {
    try {
        const { data } = await ax.get(`datahub_report/gettemplate_category/${id}`);
        return data;
    } catch (error) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response;
        }
    }
});